import Config from '../../config';
import {GetCall} from '../helper'

const URLS = {
    "MEDIA" : Config.BASE_API_URL + "/media",
}


export const GetMediaData = async(data?:any) => {
    return await GetCall(URLS.MEDIA, data, Config.DEFAULT_HEADER)
}